<script>
    import {onMount} from "svelte";
    import {mainTimeline} from "../timelines/main-timeline";
    import pageTitleInOut from "../animation-configs/pageTitleInOut";

    let openingTitleElement;

    onMount(() => {
        mainTimeline.from(openingTitleElement, pageTitleInOut, 'planetsStart');
        mainTimeline.to(openingTitleElement, pageTitleInOut, 'planetsEnd+=0.001');
    });

</script>

<div class="opening-title-container" bind:this={openingTitleElement}>
    <h2 class="title">Accelerate your <br/><span class="colourise">customer's journey</span></h2>
    <hr class="orange-line"/>
    <h3 class="standfirst">How thought leadership <br />influences the decision to buy</h3>
</div>

<style>
    .opening-title-container {
        z-index: 3;
        position: absolute;
        width: 100%;
        top: 350px;
        text-shadow: 1px 1px 10px #00000085;
        pointer-events: none;
    }

    .title {
        position: relative;
        font-weight: 600;
        top: 0;
        margin: 0;
        margin-bottom: 0.2em;
        font-size: 80px;
        color: white;
        text-align: center;
        overflow: visible;
        letter-spacing: 1px;

    }

    .colourise {
        color: #fcd0b1;

    }

    .standfirst {
        text-align: center;
        font-size: 32px;
        font-weight: 400;
        color: white;
        margin: 0 auto;
    }

    .orange-line {
        height: 3px;
        width: 75px;
        background-color: #FF8833;
        border: 0;
        border-radius: 10px;
        box-shadow: 1px 1px 10px #00000085;
        margin-bottom: 1rem;
    }

    @media screen and (max-width: 1000px) {
        .opening-title-container {
            top: 230px;
        }
    }

    @media screen and (max-width: 700px) {
        .opening-title-container {
            top: 150px;
        }
    }


    @media screen and (max-width: 700px) {
        .opening-title-container {
            top: 220px;
            scale: 1;
        }
        .title {
            font-size: 42px;
        }
        .orange-line {
            width: 60px;
            height: 2px;
        }
    }

    @media screen and (max-height: 799px) {
        .opening-title-container {
            top: 220px;
            transform: scale(0.8);
            transform-origin: top center;
        }
    }

    @media screen and (max-width: 900px) {
        .opening-title-container {
            transform: scale(0.8);
            transform-origin: top center;
        }
    }

    @media screen and (max-width: 480px) {
        .opening-title-container {
            top: 100px;
        }
    }


</style>
